// helpers
import DTM, { PAGE_TYPE, EVENTS } from 'shared/helpers/DTM';

// constants
import { INTERNATIONAL_PREFIX } from './constants';

const CHANNEL = 'NDS';

interface OnPageLoadArgs {
  isInternational?: boolean;
  NDNPageType: string;
}

export const onPageLoad = ({ isInternational = false, NDNPageType }: OnPageLoadArgs) => {
  const data: { [key: string]: string | boolean } = {};
  data.pagetype = PAGE_TYPE.HOMEPAGE;
  data.pagename = `${CHANNEL} : ${PAGE_TYPE.HOMEPAGE}`;
  data.channel = CHANNEL;
  data.eventName = EVENTS.HOMEPAGE;
  data.isInternational = isInternational;
  data.NDNPageType = isInternational ? `${INTERNATIONAL_PREFIX}${NDNPageType}` : NDNPageType;
  DTM.onPageLoad(data);
};
